/**
 * Primitive design tokens - raw color values.
 * Never use these directly in components; import semantic tokens from ./tokens instead.
 *
 * Brand source: docs/ (Clarivate Brand Portal)
 * Purple ramp derived via OKLCH interpolation from #5E33BF.
 */

export const primitives = {
  clarivatePurple: {
    50: '#F5F0FF',
    100: '#E8DCFB',
    200: '#D1B8F7',
    300: '#B175E1', // docs hover accent
    400: '#9A5FD4',
    500: '#5E33BF', // brand primary (docs source of truth)
    600: '#4B29A0',
    700: '#3A2080',
    800: '#291660',
    900: '#180D40',
  },

  neutral: {
    0: '#FFFFFF',
    25: '#FAFAFB',
    50: '#F4F5F7',
    100: '#E6E8EC',
    200: '#CDD1D8',
    300: '#A8AEBA',
    400: '#7C8493',
    500: '#5A6271',
    600: '#3F4654',
    700: '#2A2F3A',
    800: '#1A1D24',
    900: '#0E1015',
    950: '#070809',
  },

  semantic: {
    success: '#16A34A',
    warning: '#E5A50A',
    danger: '#DC2626',
    info: '#2563EB',
  },

  /** Clarivate-specific accent colours from docs */
  brand: {
    lime: '#F0FE4F',
    green: '#93FF9E',
    purpleLight: '#FAF5FF',
  },

  /** WebScraper incident/monitor UI - fixed production colors, identical in light and dark mode */
  webScraper: {
    incidentAccent: '#5E33BF',
    incidentBlocked: '#acaaaa',
    incidentLowSuccess: '#2b4059',
    failedRows: '#ED5564',
  },
} as const;
